<cc-list-detail-tool-bar
  [folder]="folder"
  [list]="listsHandler.selectedList"
  [listIsDeployed]="isListDeployed"
  [loading]="state.isLoading"
  [updating]="state.isUpdating"
  [canAddNewItem]="canAddNewItem"
  [folder]="folder"
  (listNameUpdated)="onListNameUpdated($event)"
  (addListItemStarted)="onListAddStarted()"
  (listUploaded)="$event.fileList.length > 0 && onListDataUploaded($event.list, $event.fileList)"
  (listDeployedViaCsv)="$event.fileList.length > 0 && onListDeployedViaCsv($event.list, $event.fileList)"
  (listItemStylesUpdated)="onListItemStylesUpdated($event)"
  [triggerUploadListCSV]="triggerUploadListCSV"
  (deleteItems)="onDeleteItems($event)"
>
</cc-list-detail-tool-bar>

<cc-list
  *ngIf="listsHandler.selectedList; else loadingState"
  [list]="listsHandler.selectedList"
  [folder]="folder"
  [users]="notifiableUsers$ | async"
  [canEditData]="canEditData"
  [isUploading]="state.isUploading"
  [isUpdating]="state.isUpdating"
  [canAddNewItem]="canAddNewItem"
  (listDeployed)="onListDeployed($event)"
  (listChanged)="onListChanged($event)"
  (listUploaded)="$event.fileList.length > 0 && onListDataUploaded($event.list, $event.fileList)"
  (listDeployedViaCsv)="$event.fileList.length > 0 && onListDeployedViaCsv($event.list, $event.fileList)"
  (addListItemStarted)="onListAddStarted()"
  (listItemAdded)="onListItemAdded($event)"
  (listItemUpdated)="onListItemUpdated($event)"
  [triggerUploadListCSV]="triggerUploadListCSV"
>
</cc-list>

<ng-template #loadingState>
  <div class="loading-spinner">
    <div class="cc-icon cc-icon-spinner"></div>
  </div>
</ng-template>
